module.exports = __webpack_public_path__ + "static/img/1.76d16f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/1.png
// module id = XCzQ
// module chunks = 0